import { CloseRounded } from "@mui/icons-material";
import {
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../App";
import { connect } from "react-redux";
import * as actions from "../../api/actions/pos";
import { action, controller, Server } from "../../api/Server";
import { formatDate } from "../../hooks/Method";

const ViewProd = (props) => {
  const { setShowForm, id } = props;
  const { t } = useTranslation();
  const { settings } = useContext(AppContext);
  const [cashier, setCashier] = useState();
  const [totalItem, setTotalItem] = useState(0);
  const [value, setValue] = useState({});

  useEffect(() => {
    if (id) {
      Server(controller.Sell + action.GetById).getById(id, (res) => {
        if (res.status === 200 && res.result && res.result.id) {
          var _result = res.result;
          setValue(_result);
          setCashier(_result.user.fullName);
          setTotalItem(
            _result.sellItems
              .map((j) => parseFloat(j.qty))
              .reduce((x, y) => x + y, 0)
          );
        }
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      {settings && value.id ? (
        <div>
          <div className="mb-10 d-flex j-between a-center pt-10 pl-10 pr-10">
            <div className="d-flex flex-wrap">
              <h1 className="form-title ml-10 fw-4 gray-color tx-upp border-left">
                {t("saleDetails")}
              </h1>
            </div>

            <div>
              <IconButton onClick={() => setShowForm(false)}>
                <CloseRounded />
              </IconButton>
            </div>
          </div>
          <Divider />
          <Grid container>
            <Grid item xs={12}>
              <TableContainer className="mt-20">
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("itemName")}</TableCell>
                      <TableCell>{t("quantity")}</TableCell>
                      <TableCell>{t("price")}</TableCell>
                      <TableCell>{t("total")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {value.sellItems.map((item, i) => (
                      <TableRow key={i}>
                        <TableCell>{item.product.name}</TableCell>
                        <TableCell>{item.qty}</TableCell>
                        <TableCell>
                          {settings.curSymbol +
                            " " +
                            item.price.toFixed(settings.decimal)}
                        </TableCell>
                        <TableCell>
                          {settings.curSymbol +
                            " " +
                            (item.qty * item.price).toFixed(settings.decimal)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Divider />
              <Divider />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              className="w-100pr"
              sx={{
                borderRight: { sm: "1px solid var(--grayLight-color)" },
              }}
            >
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    {value.cstmr && (
                      <TableRow>
                        <TableCell>{t("customer")}</TableCell>
                        <TableCell align="right">
                          {value.cstmr.fullName} | {value.cstmr.phone}
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell>{t("invoiceID")}</TableCell>
                      <TableCell align="right">{value.id}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("method")}</TableCell>
                      <TableCell align="right">
                        {value.payments &&
                          value.payments
                            .map((j) => (j.payMethod ? j.payMethod.title : ""))
                            .join(" | ")}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("cashier")}</TableCell>
                      <TableCell align="right">{cashier}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("status")}</TableCell>
                      <TableCell align="right">
                        <div className="fw-5">
                          {value.sellType === 2 ? (
                            <span className="bg-errorSM error-color pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
                              {t("due")}
                            </span>
                          ) : (
                            <span className="bg-successXS success-color pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
                              {t("paid")}
                            </span>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("sellDate")}</TableCell>
                      <TableCell align="right">
                        {formatDate(value.sellDate)}
                      </TableCell>
                    </TableRow>
                    {value.sellType === 2 && (
                      <>
                        <TableRow>
                          <TableCell>{t("dueDate")}</TableCell>
                          <TableCell align="right">
                            {formatDate(value.dueDate)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>{t("paidDate")}</TableCell>
                          <TableCell align="right">
                            {formatDate(value.paidDate)}
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                    {value.note && (
                      <TableRow>
                        <TableCell>{t("note")}:</TableCell>
                        <TableCell align="right">
                          <span style={{ whiteSpace: "pre-wrap" }}>
                            {value.note}
                          </span>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableHead>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} sm={6} className="w-100pr">
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("totalItem")}</TableCell>
                      <TableCell align="right">{totalItem}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("subtotal")}</TableCell>
                      <TableCell align="right">
                        {settings.curSymbol +
                          " " +
                          value.subtotal.toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        {t("tax")}({value.taxPct}%)
                      </TableCell>
                      <TableCell align="right">
                        {settings.curSymbol +
                          " " +
                          value.tax.toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        {t("discount")}{" "}
                        {value.discountType === 1 && `(${value.discount}%)`}
                      </TableCell>
                      <TableCell align="right">
                        -{" "}
                        {settings.curSymbol +
                          " " +
                          value.disAmt.toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="primary-color">
                        {t("totalPayableAmt")}
                      </TableCell>
                      <TableCell align="right" className="primary-color">
                        {settings.curSymbol +
                          " " +
                          parseFloat(value.totalPay).toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>

                    {value.sellType === 2 && (
                      <TableRow>
                        <TableCell className="error-color">
                          {t("dueAmount")}
                        </TableCell>
                        <TableCell align="right" className="error-color">
                          -{" "}
                          {settings.curSymbol +
                            " " +
                            value.dueAmt.toFixed(settings.decimal)}
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell className="success-color">
                        {t("usedCredit")}
                      </TableCell>
                      <TableCell align="right" className="success-color">
                        {settings.curSymbol +
                          " " +
                          value.creditAmt.toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>

                    {value &&
                      value.payments.map((pay, ind) => (
                        <TableRow key={ind}>
                          <TableCell className="success-color">
                            {pay.payMethod && pay.payMethod.title}
                          </TableCell>
                          <TableCell align="right" className="success-color">
                            {settings.curSymbol +
                              " " +
                              pay.amount.toFixed(settings.decimal)}
                          </TableCell>
                        </TableRow>
                      ))}
                    <TableRow>
                      <TableCell className="success-color">
                        {t("totalReceived")}
                      </TableCell>
                      <TableCell align="right" className="success-color">
                        {settings.curSymbol +
                          " " +
                          value.received.toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={
                          value.changeAddedCredit ? "success-color" : ""
                        }
                      >
                        {value.changeAddedCredit
                          ? t("creditBalance")
                          : t("change")}
                      </TableCell>
                      <TableCell
                        align="right"
                        className={
                          value.changeAddedCredit ? "success-color" : ""
                        }
                      >
                        {settings.curSymbol +
                          " " +
                          value.change.toFixed(settings.decimal)}
                      </TableCell>
                    </TableRow>
                    {value.diffAmt > 0 && (
                      <TableRow>
                        <TableCell className="error-color">
                          {t("diffAmt")}
                        </TableCell>
                        <TableCell align="right" className="error-color">
                          - {settings.curSymbol + " " + value.diffAmt}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableHead>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </div>
      ) : (
        "Loading..."
      )}
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapActionToProps = {
  _getById: actions.getById,
};

export default connect(mapStateToProps, mapActionToProps)(ViewProd);
